module.exports = __webpack_public_path__ + "img/radix.58180604.svg";